export const HEADER_ID = "dynamic-header-portal";
